var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3083",
    "data-name": "Rectangle 3083",
    width: 24,
    height: 24,
    fill: "#8a8a8a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cal",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0.857 0.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M6,5.714H23.143a2.571,2.571,0,0,1,2.571,2.571V23.714a2.571,2.571,0,0,1-2.571,2.571H6a2.571,2.571,0,0,1-2.571-2.571V8.286A2.571,2.571,0,0,1,6,5.714Z",
    transform: "translate(-3.429 -4)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinejoin: "round",
    strokeWidth: 2.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M22.169,5.714H6.974a3.577,3.577,0,0,0-3.545,3.6v3.257h.857A1.844,1.844,0,0,1,6,10.857H23.143a1.844,1.844,0,0,1,1.714,1.714h.857V9.314A3.577,3.577,0,0,0,22.169,5.714Z",
    transform: "translate(-3.429 -4)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M22,16.154A1.286,1.286,0,1,1,20.714,14.9,1.286,1.286,0,0,1,22,16.154Z",
    transform: "translate(-7.429 -6.296)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M27.714,16.154A1.286,1.286,0,1,1,26.429,14.9a1.286,1.286,0,0,1,1.286,1.255Z",
    transform: "translate(-8.857 -6.296)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M22,21.868a1.286,1.286,0,1,1-1.286-1.255A1.286,1.286,0,0,1,22,21.868Z",
    transform: "translate(-7.429 -7.725)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M27.714,21.868a1.286,1.286,0,1,1-1.286-1.255,1.286,1.286,0,0,1,1.286,1.255Z",
    transform: "translate(-8.857 -7.725)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M10.571,21.868a1.286,1.286,0,1,1-1.286-1.255A1.286,1.286,0,0,1,10.571,21.868Z",
    transform: "translate(-4.571 -7.725)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M16.286,21.868A1.286,1.286,0,1,1,15,20.613,1.286,1.286,0,0,1,16.286,21.868Z",
    transform: "translate(-6 -7.725)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M10.571,27.582a1.286,1.286,0,1,1-1.286-1.255A1.286,1.286,0,0,1,10.571,27.582Z",
    transform: "translate(-4.571 -9.153)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M16.286,27.582A1.286,1.286,0,1,1,15,26.327,1.286,1.286,0,0,1,16.286,27.582Z",
    transform: "translate(-6 -9.153)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M22,27.582a1.286,1.286,0,1,1-1.286-1.255A1.286,1.286,0,0,1,22,27.582Z",
    transform: "translate(-7.429 -9.153)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M9.143,3.429V5.143",
    transform: "translate(-4.857 -3.429)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M27.429,3.429V5.143",
    transform: "translate(-9.429 -3.429)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.286
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.0dddfc719481b187175cec875e0907ef.svg";
export { ForwardRef as ReactComponent };